import { useNavigate } from "react-router-dom";

function PrivacySecurityPage() {
  const navigate = useNavigate();

  return (
    <div className="settings-layout">
      <header
        style={{
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid #e2e8f0",
          background: "white",
          position: "sticky",
          top: 0,
          zIndex: 10,
        }}
      >
        <button
          className="settings-gear"
          onClick={() => navigate("/settings")}
          aria-label="Back"
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            fontSize: "24px",
            color: "var(--register-text)",
          }}
        >
          <span className="material-symbols-outlined">arrow_back</span>
        </button>
        <h2
          style={{
            margin: 0,
            fontSize: "20px",
            fontWeight: "600",
            flex: 1,
            textAlign: "center",
          }}
        >
          Privacy & Security
        </h2>
        <div style={{ width: "40px" }} />
      </header>

      <div
        style={{
          padding: "16px",
          maxWidth: "800px",
          margin: "0 auto",
          width: "100%",
          paddingBottom: "100px",
        }}
      >
        <section className="settings-section">
          <h3 className="settings-section-title">Data Security</h3>
          <div className="settings-card-group">
            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">lock</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Encrypted Data Transmission</p>
                  <p className="settings-value">
                    All data transmitted between your device and our servers is
                    encrypted using industry-standard TLS/SSL protocols. This
                    ensures that your information cannot be intercepted during
                    transmission.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">security</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Firebase Authentication</p>
                  <p className="settings-value">
                    We use Firebase Authentication, a secure authentication
                    service by Google, to protect your account. Your password is
                    hashed and never stored in plain text. We support
                    email/password and Google Sign-In authentication.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">
                    verified_user
                  </span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">OTP Verification</p>
                  <p className="settings-value">
                    When you update sensitive information like email or phone
                    number, we require OTP (One-Time Password) verification to
                    ensure that only you can make these changes.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card no-border">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">database</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Secure Cloud Storage</p>
                  <p className="settings-value">
                    All your data is stored securely in Google Cloud Firestore,
                    which provides enterprise-grade security, automatic backups,
                    and data encryption at rest. Your data is protected by
                    Google's security infrastructure.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="settings-section">
          <h3 className="settings-section-title">Access Control</h3>
          <div className="settings-card-group">
            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">person_pin</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">User-Based Access</p>
                  <p className="settings-value">
                    Each user can only access their own data. Our security rules
                    ensure that doctors can only view and manage their own
                    patients, appointments, and reports. Data is isolated per
                    user account.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">shield</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Firestore Security Rules</p>
                  <p className="settings-value">
                    We implement strict Firestore security rules that validate
                    user identity and permissions on every database operation.
                    Unauthorized access attempts are automatically blocked.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card no-border">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">logout</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Session Management</p>
                  <p className="settings-value">
                    Your session is securely managed by Firebase Authentication.
                    You can log out at any time, and your session will be
                    terminated immediately. Sessions expire automatically for
                    security.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="settings-section">
          <h3 className="settings-section-title">Data Privacy</h3>
          <div className="settings-card-group">
            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">
                    visibility_off
                  </span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">No Data Sharing</p>
                  <p className="settings-value">
                    We do not share, sell, or rent your personal information or
                    patient data to third parties. Your data remains private and
                    is only accessible to you through your authenticated
                    account.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">
                    admin_panel_settings
                  </span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">You Own Your Data</p>
                  <p className="settings-value">
                    All patient records, appointments, and billing information
                    belong to you. You have full control over your data and can
                    add, edit, or delete information as needed.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">backup</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Automatic Backups</p>
                  <p className="settings-value">
                    Your data is automatically backed up by Google Cloud
                    Firestore. This ensures that your information is safe and
                    can be recovered in case of any unexpected events.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card no-border">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">
                    delete_forever
                  </span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Data Deletion</p>
                  <p className="settings-value">
                    You can delete your account and all associated data at any
                    time. When you delete your account, all your data including
                    patients, appointments, and reports will be permanently
                    removed from our systems.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="settings-section">
          <h3 className="settings-section-title">Compliance & Standards</h3>
          <div className="settings-card-group">
            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">gavel</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">HIPAA Considerations</p>
                  <p className="settings-value">
                    While we implement strong security measures, please note
                    that you are responsible for ensuring HIPAA compliance in
                    your practice. We recommend consulting with a compliance
                    expert for your specific use case.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">
                    check_circle
                  </span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Industry Best Practices</p>
                  <p className="settings-value">
                    We follow industry best practices for web application
                    security, including secure authentication, encrypted
                    communications, input validation, and regular security
                    updates.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card no-border">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">update</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Regular Security Updates</p>
                  <p className="settings-value">
                    We regularly update our application and dependencies to
                    address security vulnerabilities and implement the latest
                    security improvements. Your data is protected with
                    up-to-date security measures.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="settings-section">
          <h3 className="settings-section-title">Your Responsibilities</h3>
          <div className="settings-card-group">
            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">key</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Strong Password</p>
                  <p className="settings-value">
                    Use a strong, unique password for your account. We require
                    passwords to be at least 8 characters long. Never share your
                    password with anyone.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">devices</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Secure Device</p>
                  <p className="settings-value">
                    Ensure that the device you use to access the application is
                    secure, has up-to-date software, and is protected with a
                    screen lock or password.
                  </p>
                </div>
              </div>
            </div>

            <div className="settings-info-card no-border">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">logout</span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Log Out When Done</p>
                  <p className="settings-value">
                    Always log out of your account when you're finished,
                    especially when using shared or public devices. This
                    prevents unauthorized access to your account.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="settings-section">
          <h3 className="settings-section-title">Contact & Support</h3>
          <div className="settings-card-group">
            <div className="settings-info-card no-border">
              <div className="settings-row-left">
                <div className="settings-icon-box">
                  <span className="material-symbols-outlined">
                    support_agent
                  </span>
                </div>
                <div className="settings-row-text">
                  <p className="settings-label">Security Concerns</p>
                  <p className="settings-value">
                    If you have any security concerns or notice any suspicious
                    activity on your account, please contact our support team
                    immediately. We take security seriously and will investigate
                    any reported issues.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}

export default PrivacySecurityPage;
